import { useQuery } from "urql";

import { GetFileRecommendationsByFeatureDocument } from "../../../graphql/generated";

interface UseFileRecommendationsByFeatureArgs {
  feature: string;
  inputField: string;
  customerId?: number;
}

export function useFileRecommendationsByFeature({
  feature,
  inputField,
  customerId,
}: UseFileRecommendationsByFeatureArgs) {
  return useQuery({
    query: GetFileRecommendationsByFeatureDocument,
    variables: { feature, inputField, customerId },
    pause: !feature || !inputField,
  });
}
